var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoverCloseVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5232 22.1421C1.13321 22.1421 0.743222 21.9936 0.446162 21.6958C-0.148721 21.1009 -0.148721 20.1366 0.446162 19.5417L15.2565 4.73132C15.8514 4.13644 16.8157 4.13644 17.4114 4.73132C18.007 5.3262 18.0062 6.2905 17.4114 6.88539L2.60023 21.6958C2.30241 21.9936 1.91318 22.1421 1.5232 22.1421Z",
    fill: "#00C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3336 22.1421C15.9436 22.1421 15.5536 21.9936 15.2565 21.6958L0.446162 6.88539C-0.148721 6.2905 -0.148721 5.3262 0.446162 4.73132C1.04104 4.13644 2.00535 4.13644 2.60099 4.73132L17.4114 19.5417C18.0062 20.1366 18.0062 21.1009 17.4114 21.6958C17.1135 21.9936 16.7243 22.1421 16.3343 22.1421H16.3336Z",
    fill: "#00C0C0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_498_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23804 20.7134C1.84805 20.7134 1.45807 20.5649 1.16101 20.267C0.566123 19.6722 0.566123 18.7079 1.16101 18.113L15.9714 3.30261C16.5663 2.70772 17.5306 2.70772 18.1262 3.30261C18.7218 3.89749 18.7211 4.86179 18.1262 5.45668L3.31507 20.267C3.01725 20.5649 2.62803 20.7134 2.23804 20.7134Z",
    fill: "#C000C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0484 20.7134C16.6584 20.7134 16.2684 20.5649 15.9714 20.267L1.16101 5.45668C0.566123 4.86179 0.566123 3.89749 1.16101 3.30261C1.75589 2.70772 2.72019 2.70772 3.31584 3.30261L18.1262 18.113C18.7211 18.7079 18.7211 19.6722 18.1262 20.267C17.8284 20.5649 17.4392 20.7134 17.0492 20.7134H17.0484Z",
    fill: "#C000C0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_498_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95191 19.2857C2.56192 19.2857 2.17193 19.1371 1.87487 18.8393C1.27999 18.2444 1.27999 17.2801 1.87487 16.6852L16.6852 1.87487C17.2801 1.27999 18.2444 1.27999 18.8401 1.87487C19.4357 2.46976 19.435 3.43406 18.8401 4.02894L4.02894 18.8393C3.73112 19.1371 3.34189 19.2857 2.95191 19.2857Z",
    fill: "#D8C535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7623 19.2857C17.3723 19.2857 16.9823 19.1371 16.6852 18.8393L1.87487 4.02894C1.27999 3.43406 1.27999 2.46976 1.87487 1.87487C2.46976 1.27999 3.43406 1.27999 4.0297 1.87487L18.8401 16.6852C19.435 17.2801 19.435 18.2444 18.8401 18.8393C18.5422 19.1371 18.153 19.2857 17.763 19.2857H17.7623Z",
    fill: "#D8C535"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_498_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 17.857C3.27676 17.857 2.88678 17.7084 2.58972 17.4106C1.99483 16.8157 1.99483 15.8514 2.58972 15.2565L17.4001 0.446162C17.995 -0.148721 18.9593 -0.148721 19.5549 0.446162C20.1506 1.04104 20.1498 2.00535 19.5549 2.60023L4.74379 17.4106C4.44596 17.7084 4.05674 17.857 3.66675 17.857Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4771 17.857C18.0871 17.857 17.6971 17.7084 17.4001 17.4106L2.58972 2.60023C1.99483 2.00535 1.99483 1.04104 2.58972 0.446162C3.1846 -0.148721 4.1489 -0.148721 4.74455 0.446162L19.5549 15.2565C20.1498 15.8514 20.1498 16.8157 19.5549 17.4106C19.2571 17.7084 18.8679 17.857 18.4779 17.857H18.4771Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8571,
    height: 17.8571,
    fill: "white",
    transform: "translate(0 4.28516)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_498_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8571,
    height: 17.8571,
    fill: "white",
    transform: "translate(0.714844 2.85645)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_498_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8571,
    height: 17.8571,
    fill: "white",
    transform: "translate(1.42871 1.42871)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_498_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8571,
    height: 17.8571,
    fill: "white",
    transform: "translate(2.14355)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverCloseVideo);
export default __webpack_public_path__ + "static/media/hoverCloseVideo.3b5247222441254e6732a1eeb67e0277.svg";
export { ForwardRef as ReactComponent };